import React, {
  useState,
  useImperativeHandle,
  forwardRef,
  useRef,
} from 'react';
import { message, Modal, Progress } from 'antd';
import './index.less';
import ConvertDesk from '../../../../assets/images/convert-desk.png';
import { ReactComponent as ArrowComp } from '../../../../assets/icons/bingo.svg';
import { ReactComponent as MacComp } from '../../../../assets/icons/mac.svg';
import { ReactComponent as WinComp } from '../../../../assets/icons/win.svg';
import { ReactComponent as Notice } from '@/assets/icons/notice1.svg';
import Utils from '../../../../utils';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ossCancel } from '../../../../utils/uploadFileBatch';
const ConvertDownload = forwardRef((props, ref) => {
  const { t } = useTranslation(['screenRecorder', 'common']);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDownload, setDownload] = useState(false);
  const [progress, setProgress] = useState(0);
  const [step, setStep] = useState(0);
  const workData = useSelector((state) => state.work);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    //说明处于上传进度
    setProgress(workData.processPercent / 2);

    if (workData.processPercent === 100) {
      setStep((step) => {
        return step + 1;
      });
    }
    if (step === 2) {
      setStep(0);
    }
  }, [step, workData.processPercent]);

  const openConvertSeo = () => {
    window.open(Utils.getHitPawConvertSeoLink());
  };
  useEffect(() => {
    window.addEventListener('offline', () => {
      message.error(t('CheckConnect'), 3);
      handleCancel();
    });
  }, []);

  const handleCancel = () => {
    setIsModalOpen(false);
    setDownload(false);
    setProgress(0);
    setStep(0);
    if (workData.uploadXHR) {
      workData.uploadXHR.abort();
    }
    if (workData.fetchAbort) {
      workData.fetchAbort();
    }
    ossCancel();
    Utils.cancleProgress();
  };

  const downloadDesk = () => {
    window.onbeforeunload = function () {};
    window.location.href = Utils.getHitPawConvertLink();
    window.onbeforeunload = () => {
      return 'close';
    };
  };

  const purchaseData = [
    { content: t('ConvertText1') },
    { content: t('ConvertText2') },
    { content: t('ConvertText3') },
    { content: t('ConvertText4') },
  ];
  useImperativeHandle(ref, () => ({
    setIsModalOpen,
    setDownload,
  }));

  return (
    <>
      <Modal
        className='convertModal'
        centered
        title={
          <div className='convertModalTitle'>
            {!isDownload ? (
              <>
                <div className='convertIcon'>
                  <Notice />
                </div>
                <div className='convertText'>
                  {t('Exceed100MDownloadConvert')}
                  <span className='learnMore' onClick={() => openConvertSeo()}>
                    {t('Learn more')}
                    {'>'}
                  </span>
                </div>
              </>
            ) : (
              <div className='downloadProgress'>
                <div className='downloading'>{t('Downloading')}</div>
                <Progress percent={progress} />
              </div>
            )}
          </div>
        }
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={800}
        maskClosable={false}
      >
        <div className='convertContainer'>
          <div className='convertLeft'>
            <img src={ConvertDesk} alt='' />
          </div>
          <div className='convertRight'>
            <div className='convertTitle'>HitPaw Video Converter</div>
            <div className='convertList'>
              {purchaseData.map((item, value) => {
                return (
                  <div className='convertListData' key={'convertList' + value}>
                    <div className='arrowComp'>
                      <ArrowComp />
                    </div>
                    <div>{item.content}</div>
                  </div>
                );
              })}
            </div>
            <div onClick={() => downloadDesk()} className='tryItFree'>
              {Utils.systemCheck() === 'Mac' ? (
                <MacComp className='iconComp' />
              ) : (
                <WinComp className='iconComp' />
              )}{' '}
              {t('TryItFree')}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
});
export default ConvertDownload;
